<div
  class="cfb-backdrop"
  role="dialog"
  aria-modal="true"
  aria-label="Tell us what went wrong"
  (click)="cancel()"
>
  <app-pebbl-modal class="cfb-card" title="Tell us what went wrong" (click)="$event.stopPropagation()">
    <div class="field">
      <span>Category</span>
      <ng-select
        class="pebbl-select cfb-select"
        [items]="categories"
        bindLabel="name"
        bindValue="id"
        [clearable]="false"
        [searchable]="false"
        [markFirst]="false"
        placeholder="Select"
        [(ngModel)]="category"
        [ngModelOptions]="{ standalone: true }"
      ></ng-select>
    </div>

    <div class="field cfb-field--last">
      <span>Feedback Text</span>
      <textarea
        class="cfb-textarea"
        rows="4"
        placeholder="Enter feedback text"
        [(ngModel)]="text"
        [ngModelOptions]="{ standalone: true }"
      ></textarea>
    </div>

    <div class="pm-foot">
      <button type="button" class="btn-secondary" (click)="cancel()">Cancel</button>
      <button type="button" class="btn-primary" [disabled]="!canSubmit" (click)="submit()">
        Submit
      </button>
    </div>
  </app-pebbl-modal>
</div>
